<template>
    <div class="content">
        <div class="top-box">
            <div class="btn btn-home" @click="toHome">数据概览</div>
            <div class="btn btn-device" @click="toDevice">设备管理</div>
            <div class="btn-active btn-patient" @click="toUser">患者管理</div>
            <div class="btn btn-data" @click="toData">手表数据</div>
            <div class="btn-admin"></div>
            <img class="btn-icon" src="@/assets/home/04icon.png">
            <div class="user-name" @click="toAdmin">{{ loginName }}</div>
            <div class="time-box">{{ time }}</div>
        </div>
        <div class="main">
            <el-form :inline="true" label-position="top" size="mini">
                <el-form-item label="患者">
                    <el-input v-model="userName" placeholder="请输入患者名称"></el-input>
                </el-form-item>
                <el-form-item label="性别">
                    <el-select v-model="userSex" placeholder="请选择">
                        <el-option
                            label="全部"
                            value="">
                        </el-option>
                        <el-option
                            label="男"
                            value="1">
                        </el-option>
                        <el-option
                            label="女"
                            value="0">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="联系方式">
                    <el-input v-model="phone" placeholder="请输入患者联系电话"></el-input>
                </el-form-item>
                <el-form-item label="所属科室">
                    <el-select  placeholder="请选择">
                        <el-option
                            label="全部"
                            value="">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div class="btn-box">
                <div>
                    <el-button type="primary" @click="addVisible = true" size="mini" icon="el-icon-plus">新增患者
                    </el-button>
                    <el-button type="primary" @click="importTag = true" size="mini" icon="el-icon-plus" plain>批量增加
                    </el-button>
                    <el-button type="danger" @click="openDeleteDevice(1)" size="mini" icon="el-icon-close">删除患者</el-button>
                </div>
                <div>
                    <el-button type="info" @click="reset" size="mini">重置</el-button>
                    <el-button type="primary" @click="search" size="mini">查询</el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                stripe
                border
                style="width: 100%"
                @selection-change="tableSelectionChange">
                <el-table-column type="selection"
                                 width="40">
                </el-table-column>
                <el-table-column
                    prop="userId"
                    label="ID"
                >
                </el-table-column>
                <el-table-column
                    prop="userName"
                    label="姓名"
                >
                </el-table-column>

                <el-table-column label="性别">
                    <template slot-scope="scope">
                        {{ scope.row.userSex === 1 ? '男' : '女' }}
                    </template>
                </el-table-column>
                <el-table-column
                    prop="userAge"
                    label="年龄"
                >
                </el-table-column>
                <el-table-column
                    prop="phone"
                    label="联系电话"
                >
                </el-table-column>
                <el-table-column
                    prop="ward"
                    label="病房号"
                >
                </el-table-column>
                <el-table-column
                    prop="versionDec"
                    label="操作"
                    width="150">
                    <template slot-scope="scope">
                        <div>
                            <div class="table-btn table-btn0" @click="openEditUser(scope.row)">编辑</div>
                            <div class="table-btn table-btn1" @click="openUserBoard(scope.row)">个人档案</div>
                            <div class="table-btn table-btn2" @click="openDeleteDevice(0, scope.row)">删除</div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div style="margin-top: 15px">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageNum"
                    :page-sizes="[20, 30, 40, 50]"
                    :page-size="20"
                    layout="prev, pager, next, sizes, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
        <el-dialog
            title="编辑患者"
            :visible.sync="addVisible"
            width="700px"
            :fullscreen="false"
            :close-on-click-modal="false"
        >
            <el-form size="mini">
                <el-form-item label="姓名" label-width="100px">
                    <el-input
                        type="text"
                        placeholder="请输入"
                        v-model="user.userName">
                    </el-input>
                </el-form-item>
                <el-form-item label="性别" label-width="100px">
                    <el-select v-model="user.userSex" placeholder="请选择">
                        <el-option
                            label="男"
                            value="1">
                        </el-option>
                        <el-option
                            label="女"
                            value="0">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="出生年月" label-width="100px">
                    <el-date-picker
                        v-model="user.userBirthday"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="联系电话" label-width="100px">
                    <el-input
                        type="text"
                        placeholder="请输入"
                        maxlength="11"
                        v-model="user.phone">
                    </el-input>
                </el-form-item>
                <el-form-item label="病房号" label-width="100px">
                    <el-input
                        type="text"
                        placeholder="请输入"
                        v-model="user.ward">
                    </el-input>
                </el-form-item>
                <el-form-item label="病情描述" label-width="100px">
                    <el-input
                        type="textarea"
                        placeholder="请输入"
                        rows="3"
                        v-model="user.condition">
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="info" @click="addVisible = false" size="mini">取消</el-button>
                   <el-button type="primary" @click="addUser()" size="mini">提交</el-button>
            </span>
        </el-dialog>
        <el-dialog
            title="导入数据"
            :visible.sync="importTag"
            width="600px"
            :fullscreen="false"
            :before-close="cancelFc"
        >
            <div>
                <input type="file" ref="fileInput" @change="importExcel"/>
                <el-table
                    :data="excelData"
                    style="width: 100%"
                    height='300'
                    border
                    stripe
                    lazy
                >
                    <el-table-column
                        prop="userName"
                        label="姓名"
                    >
                    </el-table-column>

                    <el-table-column label="性别">
                        <template slot-scope="scope">
                            {{ scope.row.userSex === 1 ? '男' : '女' }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="userBirthday"
                        label="出生年月"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="phone"
                        label="联系电话"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="ward"
                        label="病房号"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="condition"
                        label="病情描述"
                    >
                    </el-table-column>
                </el-table>
                <div>共 {{ excelData.length }} 条数据</div>
            </div>
            <span slot="footer" class="dialog-footer">
                    <el-button type="info" @click="cancelFc" size="mini">取消</el-button>
                 <el-button type="primary" @click="importFc()" size="mini">确认</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import * as XLSX from 'xlsx';

export default {
    name: 'index',
    data() {
        return {
            loginName:localStorage.getItem("phone"),
            ratio: 1,
            time: '',
            phone: '',
            mac: '',
            sn: '',
            watchType: '',
            deviceType: '',
            userName: '',
            userSex: '',
            isBind: '',
            watchModel: [],
            tableData: [],
            total: 0,
            pageNum: 1,
            pageSize: 20,
            tableSelection: '',
            addVisible: false,
            user: {
                userName: '',
                userSex: '',
                userBirthday: '',
                phone: '',
                userLocation: '',
                userMsg: '',
            },
            importTag: false,
            excelData: []
        }
    },
    mounted() {
        this.ratio = document.documentElement.clientHeight / 1080;
        this.startTimer();
        this.getWatchModelList();
        this.search()
    },
    methods: {
        toHome() {
            this.$router.push({
                path: '/home',
            })
        },
        toDevice() {
            this.$router.push({
                name: 'device'
            })
        },
        toAdmin() {
            this.$router.push({
                name: 'admin'
            })
        },
        toUser() {
            this.$router.push({
                name: 'user'
            })
        },
        toData() {
            this.$router.push({
                name: 'data'
            })
        },
        getTime() {
            let time = new Date();
            let year = time.getFullYear();
            let month = (time.getMonth() + 1).toString().padStart(2, '0');
            let day = time.getDate().toString().padStart(2, '0');
            let hour = time.getHours().toString().padStart(2, '0');
            let minute = time.getMinutes().toString().padStart(2, '0');
            let second = time.getSeconds().toString().padStart(2, '0');
            this.time = year + '/' + month + '/' + day + '\n' + hour + ':' + minute + ':' + second;
            this.latestTime = this.time
        },
        startTimer() {
            // 立即执行一次
            this.getTime();
            // 每秒执行一次
            setInterval(() => {
                this.getTime();
            }, 1000);
        },
        getWatchModelList() {
            this.$api.device.getWatchModelList({
                pageNum: 1,
                pageSize: 200
            }).then(res => {
                let data = res.data.items
                this.watchModel = [];
                for (let i = 0; i < data.length; i++) {
                    let modelList = data[i].model.split(',');
                    let type = {
                        value: data[i].type,
                        label: data[i].type,
                        children: []
                    };
                    for (let j = 0; j < modelList.length; j++) {
                        let model = {
                            value: modelList[j],
                            label: modelList[j]
                        };
                        type.children.push(model)
                    }
                    this.watchModel.push(type);
                }
            })
        },
        tableSelectionChange(val) {
            this.tableSelection = val;
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.search();
        },
        handleCurrentChange(val) {
            this.pageNum = val;
            this.search();
        },
        search() {
            this.$api.user.getUserList({
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                userName: this.userName,
                userSex: this.userSex,
                userPhone: this.phone
            }).then(response => {
                this.tableData = response.data.items;
                this.total = response.data.count;
                if (this.total != 0 && this.tableData.length == 0) {
                    this.pageNum = 1;
                    this.search()
                }
            })
        },
        reset() {
            this.userName = '';
            this.userSex = '';
            this.phone = '';
            this.search();
        },
        addUser() {
            if (this.user.userId) {
                this.$api.user.updateUser({
                    userId: this.user.userId,
                    userName: this.user.userName,
                    userSex: this.user.userSex,
                    userBirthday: this.user.userBirthday,
                    phone: this.user.phone,
                    ward: this.user.ward,
                    condition: this.user.condition,
                }).then(res => {
                    this.$message.success('修改成功');
                    this.addVisible = false;
                    this.search();
                    this.user = {
                        userName: '',
                        userSex: '',
                        userBirthday: '',
                        phone: '',
                        ward: '',
                        condition: ''
                    }
                })
            } else {
                this.$api.user.addUser({
                    userName: this.user.userName,
                    userSex: this.user.userSex,
                    userBirthday: this.user.userBirthday,
                    phone: this.user.phone,
                    ward: this.user.ward,
                    condition: this.user.condition
                }).then(res => {
                    this.$message.success('添加成功');
                    this.user = {
                        userName: '',
                        userSex: '',
                        userBirthday: '',
                        phone: '',
                        ward: '',
                        condition: ''
                    }
                    this.addVisible = false;
                    this.search();
                })
            }
        },
        importExcel(event) {
            let files = event.target.files;
            let fileReader = new FileReader();
            fileReader.onload = (ev) => {
                try {
                    var data = ev.target.result,
                        workbook = XLSX.read(data, {
                            type: 'binary'
                        }), // 以二进制流方式读取得到整份excel表格对象
                        excelData = []; // 存储获取到的数据
                } catch (e) {
                    console.log('文件类型不正确');
                    return;
                }

                // 表格的表格范围，可用于判断表头是否数量是否正确
                var fromTo = '';
                // 遍历每张表读取
                for (var sheet in workbook.Sheets) {
                    if (workbook.Sheets.hasOwnProperty(sheet)) {
                        fromTo = workbook.Sheets[sheet]['!ref'];
                        excelData = excelData.concat(XLSX.utils.sheet_to_json(workbook.Sheets[sheet]));
                        // break; // 如果只取第一张表，就取消注释这行
                    }
                }
                this.dealExcelData(excelData)
            };
            fileReader.readAsBinaryString(files[0]);
        },
        dealExcelData(arr) {
            this.excelData = [];
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].姓名) {
                    this.excelData.push({
                        userName: arr[i].姓名,
                        userSex: arr[i].性别 == '男' ? 1 : 0,
                        userBirthday: this.formatExcelDate(arr[i].出生年月),
                        phone: arr[i].联系电话,
                        ward: arr[i].病房号,
                        condition: arr[i].病情描述
                    })
                }
            }
        },
        cancelFc() {
            this.importTag = false;
            this.excelData = [];
            const fileInput = this.$refs.fileInput;
            if (fileInput) {
                fileInput.value = ''; // 清空文件输入框
            }
        },
        importFc() {
            this.$api.user.importUser(this.excelData).then(res => {
                if (res.result == 1) {
                    this.$message({
                        message: '导入成功',
                        type: 'success'
                    });
                    this.search()
                    this.cancelFc()
                }
            })
        },
        openDeleteDevice(tag, item) {
            this.$confirm('确定要删除?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let deleteData = [];
                if (tag === 0) {
                    deleteData = [item]
                } else {
                    deleteData = this.tableSelection
                }
                this.deleteDevice(deleteData)
            })
        },
        deleteDevice(deleteData) {
            this.$api.user.deleteUser(deleteData).then(res => {
                if (res.result == 1) {
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    });
                    this.search()
                }
            })
        },
        openEditUser(user) {
            this.user = {
                ...user,
                userSex: user.userSex !== undefined ? String(user.userSex) : null
            }
            this.addVisible = true
        },
        openUserBoard(user) {
            window.open('https://service.beidouwatch.com/board_dzkd_user/#/?userId=' + user.userId, '_blank')
        },
        deleteWatchBind(item) {
            this.$confirm('确定要解绑?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.device.deleteWatchBind(item).then(res => {
                    if (res.result == 1) {
                        this.$message({
                            message: '解绑成功',
                            type: 'success'
                        });
                        this.search()
                    }
                })
            })
        },
        formatExcelDate(num) {
            // 检查是否为数字
            if (typeof num !== 'number' || isNaN(num)) return num;

            // Excel错误的将1900年视为闰年，需要对60（1900-02-29）这个无效日期做校正[citation:2]
            const offset = num < 60 ? 0 : 1;
            // 计算从1900-01-00到目标日期的天数差，并转换为时间戳
            const utcDays = (num - offset) * 86400000; // 1天 = 86400000毫秒
            // 使用UTC时间创建Date对象，避免时区干扰
            const date = new Date(Date.UTC(1900, 0, 0) + utcDays);

            // 提取年、月、日，并格式化为两位
            const year = date.getUTCFullYear();
            const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // 月份从0开始
            const day = String(date.getUTCDate()).padStart(2, '0');

            return `${year}-${month}-${day}`;
        }
    }
}
</script>

<style scoped>
.content {
    width: 1920px;
    height: 1080px;
    background-color: #0A192F;
    background-image: url("~@/assets/home/01bg.png");
    background-size: cover;
    box-sizing: border-box;
    overflow-x: hidden;
    font-size: 14px;
}

.main {
    width: 1728px;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 0px 0px 0px 0px;
    margin: 0 auto;
    padding: 38px 53px 20px 32px;
    font-size: 14px;
}

/deep/ .el-input__inner {
    background-color: rgba(0, 111, 255, 0.1);
    color: #ffffff;
    border: 1px solid rgba(0, 136, 255, 0.6);
}

/deep/ .el-cascader__dropdown {
    background: rgba(0, 111, 255, 0.1);
}

/deep/ .el-range-input {
    background-color: rgba(0, 111, 255, 0.1);
    color: #ffffff;
}

/deep/ i {
    font-size: 12px;
}

.btn-box {
    display: flex;
    justify-content: space-between;
    margin-bottom: 32px;
}

.table-btn {
    display: inline-block;
    margin-right: 10px;
    cursor: pointer;
}

.table-btn0 {
    color: #0088FF;
}

.table-btn1 {
    color: #1CB9FF;
}

.table-btn2 {
    color: #FF3A62;
}

/deep/ .el-table {
    height: 600px !important;
}
</style>


// WEBPACK FOOTER //
// src/views/user/index.vue